import { Entity } from '@app/constants/enums/entites';
import { IChannelUnreadMessage } from '@app/interfaces/channel';
import { IDealRoom, IDealRoomMessage } from '@app/interfaces/deal-room';
import { IDealRoomInfo } from '@app/interfaces/deal-room-info';
import { createAction, createSlice, PrepareAction } from '@reduxjs/toolkit';

export interface DealRoomState {
  dealRoom: IDealRoom | null;
  dealRoomInfo: IDealRoomInfo | null;
  dealRoomChat: number;
  dealRoomClickMessage: IDealRoomMessage | null;
  dealRoomMessage: IDealRoomMessage | null;
  unreadMessages: IChannelUnreadMessage;
}

const initialState: DealRoomState = {
  dealRoom: null,
  dealRoomInfo: null,
  dealRoomChat: 0,
  dealRoomClickMessage: null,
  dealRoomMessage: null,
  unreadMessages: { unreadMessages: 0, unreadMessagesByDealRoom: [] },
};

export const setDealRoom = createAction<PrepareAction<IDealRoom>>('dealRoom/setDealRoom', (newDealRoom) => {
  return {
    payload: newDealRoom,
  };
});

export const setDealRoomInfo = createAction<PrepareAction<IDealRoomInfo>>(
  'dealRoom/setDealRoomInfo',
  (newDealRoomInfo) => {
    return {
      payload: newDealRoomInfo,
    };
  },
);

export const setDealRoomChat = createAction<PrepareAction<number>>('dealRoom/setDealRoomChat', (newDealRoomChat) => {
  return {
    payload: newDealRoomChat,
  };
});

export const setDealRoomClickMessage = createAction<PrepareAction<IDealRoomMessage | null>>(
  'dealRoom/setDealRoomClickMessage',
  (newDealRoomClickMessage) => {
    return {
      payload: newDealRoomClickMessage,
    };
  },
);

export const setDealRoomMessage = createAction<PrepareAction<IDealRoomMessage | null>>(
  'dealRoom/setDealRoomMessage',
  (newDealRoomMessage) => {
    return {
      payload: newDealRoomMessage,
    };
  },
);

export const setUnreadMessages = createAction<PrepareAction<IChannelUnreadMessage>>(
  'dealRoom/setUnreadMessages',
  (newUnreadMessages) => {
    return {
      payload: newUnreadMessages,
    };
  },
);

export const dealRoomSlice = createSlice({
  name: Entity.DEAL_ROOM,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setDealRoom, (state, action) => {
      state.dealRoom = action.payload;
    });
    builder.addCase(setDealRoomInfo, (state, action) => {
      state.dealRoomInfo = action.payload;
    });
    builder.addCase(setDealRoomChat, (state, action) => {
      state.dealRoomChat = action.payload;
    });
    builder.addCase(setDealRoomClickMessage, (state, action) => {
      state.dealRoomClickMessage = action.payload;
    });
    builder.addCase(setDealRoomMessage, (state, action) => {
      state.dealRoomMessage = action.payload;
    });
    builder.addCase(setUnreadMessages, (state, action) => {
      state.unreadMessages = action.payload;
    });
  },
});

export default dealRoomSlice.reducer;
